// @helpers
const dateHelper = require('utilities/dateHelper');

// @core
const { formatText } = require('core/i18n').i18n;

//@actions
const { validateAndExecute } = require('../signaturePattern');

const {
    FETCH_IMPOSITION_EARLY_CANCELLATION_DATA_REQUEST,
    FETCH_IMPOSITION_EARLY_CANCELLATION_DATA_SUCCESS,
    FETCH_IMPOSITION_EARLY_CANCELLATION_DATA_FAILURE,

    EARLY_CANCEL_IMPOSITION_REQUEST,
    EARLY_CANCEL_IMPOSITION_SUCCESS,
    EARLY_CANCEL_IMPOSITION_FAILURE,

    EARLY_IMPOSITION_CANCEL_SET_VISIBLE_STEP,
    EARLY_IMPOSITION_CANCEL_VALIDATE,
    EARLY_CANCEL_IMPOSITION_SHOW_CANCEL_MODAL,
} = require('constants/contactCenter/actionTypes');
const apiRequestHelper = require('utilities/APIRequestHelper');
const { SAVING } = require('constants/contactCenter/depositOrImpositionCancellationStatus');



const requestImpositionEarlyCancellationDataInProgress = payload => ({
    type: FETCH_IMPOSITION_EARLY_CANCELLATION_DATA_REQUEST,
    payload
});

const requestImpositionEarlyCancellationDataSuccess = payload => ({
    type: FETCH_IMPOSITION_EARLY_CANCELLATION_DATA_SUCCESS,
    payload
});

const requestImpositionEarlyCancellationDataFailure = error => ({
    type: FETCH_IMPOSITION_EARLY_CANCELLATION_DATA_FAILURE,
    payload: {
        error
    }
});

const earlyCancelImpositionInProgress = () => ({
    type: EARLY_CANCEL_IMPOSITION_REQUEST
});

const earlyCancelImpositionSuccess = payload => ({
    type: EARLY_CANCEL_IMPOSITION_SUCCESS,
    payload
});

const earlyCancelImpositionFailure = error => ({
    type: EARLY_CANCEL_IMPOSITION_FAILURE,
    payload: {
        error
    }
});

const setVisibleStep = step => ({
    type: EARLY_IMPOSITION_CANCEL_SET_VISIBLE_STEP,
    payload: {
        step
    }
});

const showCancelModal = (show) => ({
    type: EARLY_CANCEL_IMPOSITION_SHOW_CANCEL_MODAL,
    payload: {
        show
    }
});

const validateStep = step => ({
    type: EARLY_IMPOSITION_CANCEL_VALIDATE,
    payload: {
        step
    }
});


const queryImpositionEarlyCancellationData = (depositId, impositionId) => (dispatch, getState) => {
    const state = getState();
    const immDeposit = state.deposits.getIn(['byId', depositId]);
    dispatch(requestImpositionEarlyCancellationDataInProgress({depositId, impositionId}));

    if (immDeposit) {
        return apiRequestHelper.APIPost({
            dispatch,
            endpoint: 'queryImpositionEarlyCancellationData',
            params: {
                query: {
                    "contrato": {
                        "numerodecontrato": immDeposit.getIn(['contract', 'contractNumber']),
                        "producto": immDeposit.getIn(['contract', 'product'])
                    },
                    "numImposicion": impositionId
                }
            }
        })
        .then(response => dispatch(requestImpositionEarlyCancellationDataSuccess(response)))
        .catch(response => dispatch(requestImpositionEarlyCancellationDataFailure(response.error)));

    } else {
        dispatch(requestImpositionEarlyCancellationDataFailure(
            {
                description: formatText('cancelImposition-impositionNotFound'),
            }
        ));
    }
};

const earlyCancelImpositionRequest = (immCancellationData, immImposition, dataToken) => (dispatch, getState) => {
    const { impositionEarlyCancellation } = getState();
    const isAlreadyFetching = impositionEarlyCancellation.get('status') === SAVING;

    if (!isAlreadyFetching) {

        const currency = immImposition.get('currency');
        const amount = immImposition.get('amount');

        dispatch(earlyCancelImpositionInProgress());

        const {
            codigoMonedaCuentaAsociadaCODMOCTA,
            codigoMonedaDisposicionCODMONSW,
            codigoVariable2CODIVAR2,
            codigoVariableParaValidarCODIVAR1,
            fechaValorCtaAsociadaOcuFECVAL22,
            fechaValorCuentaAsociadaFECVAL2,
            fechaValorDisposicionFECVAL1,
            fechaValorDisposicionOcuFECVAL11,
            importeCuentaAsociadaOcuAIMPORS,
            importeDisposicionOcuAIMPORM,
            referenciaOcuAREFCONC,
            numeroLineaPantallaNUMMOD,
            destinoFondosCODAPL,
            destinoFondosOcuCODAP,
            referenciaREFCORON,
            subgrupoCuentaAsociadaOcuSUBGRC2,
            subgrupoCuentaAsociadaSUBGRCA,
            numeroSubcontratoOcuIDSCONTT,
            codigoPersonaCODPERS,
            tipoPersonaTIPOPERS,
            codigoPersonaOcuZCODPER,
            tipoPersonaOcuZTIPOPER,
            numeroContratoOcuIDCONTR1,
            numeroContratoCtaAsociadaIDCONTCA,
            numContratoCtaAsociadaOcuIDCONTC2,
            codigoCentroOcuIDCENT1,
            codigoEmpresaOcuIDEMPR01,
            codigoProductoOcuIDPROD1,
            codigoCentroCuentaAsociadaIDCENTCA,
            codigoEmpresaCtaAsociadaIDEMPRCA,
            codigoCentroCtaAsociadaOcuIDCENT2,
            codigoEmpresaCtaAsociadaOcuIDEMPR2,
        } = immCancellationData.toJS();

        const query = {
            canalMarco: "CIC",
            codigoMonedaCuentaAsociadaCODMOCTA,
            codigoMonedaDisposicionCODMONSW,
            codigoVariable2CODIVAR2,
            codigoVariableParaValidarCODIVAR1,
            contrato: {
                centro: {
                    centro: codigoCentroOcuIDCENT1,
                    empresa: codigoEmpresaOcuIDEMPR01
                },
                numerodecontrato: numeroContratoOcuIDCONTR1,
                producto: codigoProductoOcuIDPROD1
            },
            contratoOcu: {
                centro: {
                    centro: codigoCentroOcuIDCENT1,
                    empresa: codigoEmpresaOcuIDEMPR01
                },
                numerodecontrato: numeroContratoOcuIDCONTR1,
                producto: codigoProductoOcuIDPROD1
            },
            cuentaAsociada: {
                centro: {
                    centro: codigoCentroCuentaAsociadaIDCENTCA,
                    empresa: codigoEmpresaCtaAsociadaIDEMPRCA
                },
                numerodecontrato: numeroContratoCtaAsociadaIDCONTCA,
                producto: codigoProductoOcuIDPROD1
            },
            cuentaAsociadaOcu: {
                centro: {
                    centro: codigoCentroCtaAsociadaOcuIDCENT2,
                    empresa: codigoEmpresaCtaAsociadaOcuIDEMPR2
                },
                numerodecontrato: numContratoCtaAsociadaOcuIDCONTC2,
                producto: codigoProductoOcuIDPROD1
            },
            dataToken,
            destinoFondosCODAPL,
            destinoFondosOcuCODAP,
            empresa: codigoEmpresaOcuIDEMPR01,
            fechaValorCtaAsociadaOcuFECVAL22: dateHelper.fromArray(fechaValorCtaAsociadaOcuFECVAL22),
            fechaValorCuentaAsociadaFECVAL2: dateHelper.fromArray(fechaValorCuentaAsociadaFECVAL2),
            fechaValorDisposicionFECVAL1: dateHelper.fromArray(fechaValorDisposicionFECVAL1),
            fechaValorDisposicionOcuFECVAL11: dateHelper.fromArray(fechaValorDisposicionOcuFECVAL11),
            idioma: {
                dialectoiso: "es",
                idiomaiso: "ES"
            },
            importeACancelar: {
                divisa: currency,
                importe: amount
            },
            importeCuentaAsociadaOcuAIMPORS: {
                divisa: currency,
                importe: importeCuentaAsociadaOcuAIMPORS
            },
            importeDisposicionOcuAIMPORM: {
                divisa: currency,
                importe: importeDisposicionOcuAIMPORM
            },
            numImposicion: immImposition.get('id'),
            numeroLineaPantallaNUMMOD,
            numeroSubcontratoOcuIDSCONTT,
            persona: {
                codigodepersona: codigoPersonaCODPERS,
                tipodepersona: tipoPersonaTIPOPERS
            },
            persona1: {
                codigodepersona: codigoPersonaCODPERS,
                tipodepersona: tipoPersonaTIPOPERS
            },
            persona2: {
                codigodepersona: codigoPersonaOcuZCODPER,
                tipodepersona: tipoPersonaOcuZTIPOPER
            },
            referenciaOcuAREFCONC,
            referenciaREFCORON,
            subgrupoCuentaAsociadaOcuSUBGRC2,
            subgrupoCuentaAsociadaSUBGRCA
        }

        return apiRequestHelper.APIPost({
            dispatch,
            endpoint: 'earlyCancelImposition',
            params: {
                query
            }
        })
        .then(response => dispatch(earlyCancelImpositionSuccess(response)))
        .catch(response => dispatch(earlyCancelImpositionFailure(response.error)));
    }
};

const earlyCancelImposition = (immCancellationData, depositId, impositionId) => (dispatch, getState) => {
    const immDeposits = getState().deposits;
    const immImposition = immDeposits.getIn(['byId', depositId, 'impositionList', 'byId', impositionId]);

    validateAndExecute(dispatch, getState, (dispatch, getState, dataToken) => {
        dispatch(earlyCancelImpositionRequest(immCancellationData, immImposition, dataToken));
    });
}

module.exports = {
    queryImpositionEarlyCancellationData,
    earlyCancelImposition,
    setVisibleStep,
    validateStep,
    showCancelModal,
};
